export default __webpack_public_path__ + "static/media/vid.6f142f61.png";